"use client";

import React from "react";
import { useLocale } from "@/content/i18n/context";
import { t } from "@/content/i18n/messages";

export interface ServiceInfoBoxProps {
  title: string;
  description?: string;
  children?: React.ReactNode;
  variant?: "neutral" | "blue" | "custom";
  backgroundColor?: string;
  borderColor?: string;
  titleColor?: string;
  className?: string;
}

export default function ServiceInfoBox({
  title,
  description,
  children,
  variant = "neutral",
  backgroundColor,
  borderColor,
  titleColor = "text-neutral-emphasis",
  className = ""
}: ServiceInfoBoxProps) {
  const locale = useLocale();
  const translate = (text: string) => t(locale, text);
  const translatedTitle = translate(title);
  const translatedDescription = description ? translate(description) : "";

  const getVariantClasses = () => {
    switch (variant) {
      case "blue":
        return "bg-card border-border";
      case "custom":
        return `${backgroundColor || "bg-card"} ${borderColor || "border-border"}`;
      case "neutral":
      default:
        return "bg-card border-border";
    }
  };

  return (
    <div
      className={`rounded-2xl border p-6 ${getVariantClasses()} ${className}`}
    >
      {title ? (
        <h4 className={`mb-3 font-display text-xl font-semibold ${titleColor}`}>
          {translatedTitle}
        </h4>
      ) : null}

      {description && (
        <p className="mb-4 text-neutral-muted">{translatedDescription}</p>
      )}

      {children}
    </div>
  );
}
